const system = require("@/libs/system");
const VERSION = '3.3.0'
const DATE = '2022.05.24'
const AndroidLink = `https://satic.web.ikea.cn/apk/ikea-v${VERSION}.apk`;
const iOSLink = "https://itunes.apple.com/cn/app/ikea%E5%AE%9C%E5%AE%B6%E5%AE%B6%E5%B1%85/id1487448370";

module.exports = {
  appVersion() {
    return {
      version: VERSION,
      date: DATE
    }
  },
  open(version) {
    const currentSystem = system.currentSystem()
    if (currentSystem === "iOS") {
      window.location.replace(iOSLink);
      return;
    }
    if (currentSystem === "Android") {
      var ifr = document.createElement('iframe');
      ifr.src = 'market://details?id=com.ingka.ikea.app.cn.prod';
      ifr.style.display = 'none';
      document.body.appendChild(ifr);
      setTimeout(function () {
        if (document.hidden) {
          document.body.removeChild(ifr);
        } else {
          if (version) {
            location.href = `https://satic.web.ikea.cn/apk/ikea-v${version}.apk`;
          } else {
            location.href = AndroidLink;
          }
        }
      }, 5000);
      return;
    }
    if (version) {
      location.href = `https://satic.web.ikea.cn/apk/ikea-v${version}.apk`;
    } else {
      location.href = AndroidLink;
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/appstore.js